<div class="campaign-dashboard">
  <!-- Header con indicador de auto-refresh -->
  <div class="dashboard-header">
    <h3>
      <i class="fa-solid fa-chart-line"></i> Dashboard de Campañas
    </h3>
    
    <!-- Badge de Auto-Refresh -->
    <div class="auto-refresh-badge" 
         [class.active]="campaignService.autoRefreshEnabled"
         [class.inactive]="!campaignService.autoRefreshEnabled"
         [pTooltip]="campaignService.autoRefreshEnabled 
           ? 'Las campañas se actualizan automáticamente cada 30 segundos' 
           : 'La actualización automática está pausada. Usa el botón Auto-Refresh para activar'"
         tooltipPosition="left">
      <i class="fa-solid" 
         [class.fa-sync]="campaignService.autoRefreshEnabled"
         [class.fa-spin]="campaignService.autoRefreshEnabled"
         [class.fa-pause-circle]="!campaignService.autoRefreshEnabled"></i>
      <span *ngIf="campaignService.autoRefreshEnabled">Auto-refresh activo</span>
      <span *ngIf="!campaignService.autoRefreshEnabled">Auto-refresh pausado</span>
    </div>
  </div>
  
  <div class="grid">
    <!-- Métricas principales -->
    <div class="col-12 md:col-6 lg:col-3">
      <div class="metric-card">
        <i class="fa-solid fa-list"></i>
        <div class="metric-content">
          <h4>Total Campañas</h4>
          <p class="metric-value">{{ metrics.total || 0 }}</p>
        </div>
      </div>
    </div>
    
    <div class="col-12 md:col-6 lg:col-3">
      <div class="metric-card pending">
        <i class="fa-solid fa-clock"></i>
        <div class="metric-content">
          <h4>Pendientes</h4>
          <p class="metric-value">{{ metrics.pending || 0 }}</p>
        </div>
      </div>
    </div>
    
    <div class="col-12 md:col-6 lg:col-3">
      <div class="metric-card completed">
        <i class="fa-solid fa-check-circle"></i>
        <div class="metric-content">
          <h4>Completadas</h4>
          <p class="metric-value">{{ metrics.completed || 0 }}</p>
        </div>
      </div>
    </div>

    <div class="col-12 md:col-6 lg:col-3">
      <div class="metric-card failed">
        <i class="fa-solid fa-times-circle"></i>
        <div class="metric-content">
          <h4>Fallidas</h4>
          <p class="metric-value">{{ metrics.failed || 0 }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
